import { render, staticRenderFns } from "./HelpShopFollow.vue?vue&type=template&id=6dceb3a3&"
import script from "./HelpShopFollow.vue?vue&type=script&lang=js&"
export * from "./HelpShopFollow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports